(() => {
    async function customAddToCart() {
        console.log(window._cpb.settings, 'window._cpb.settings');

        if (!window._cpb.settings) {
            window._cpb.settings = {};
        }

        window._cpb.settings.addToCartOverride = async (data) => {
            const api = await window.CPB.createFrontApi();

            let qtyStepOption;

            api.State.Product.panels.forEach((panel) => {
                panel.categories.forEach((category) => {
                    if (category.extraClassName === '--qty-step') {
                        category.options.forEach((option) => {
                            qtyStepOption = option;
                        });
                    }
                });
            });

            const qtyStep = qtyStepOption?.option?.data?.inputStep;

            if (qtyStep) {
                data.items.forEach((item) => {
                    item.properties._qtyStep = qtyStep;
                });
            }

            const params = new URLSearchParams(window.location.search);
            const modifyProductKey = params.get('modifyProduct');

            try {
                /*
                 * When editing an existing CPB cart item,
                 * remove the old item before adding the updated one.
                 */
                if (modifyProductKey) {
                    console.log(
                        '[CPB Modify] removing old cart item:',
                        modifyProductKey
                    );

                    const removeResponse = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                        },
                        body: JSON.stringify({
                            id: modifyProductKey,
                            quantity: 0,
                        }),
                    });

                    if (!removeResponse.ok) {
                        throw new Error(
                            `Failed to remove old cart item: ${removeResponse.status}`
                        );
                    }

                    console.log('[CPB Modify] old cart item removed');
                }

                const addResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                    },
                    body: JSON.stringify({
                        items: data.items,
                    }),
                });

                if (!addResponse.ok) {
                    throw new Error(
                        `Failed to add product to cart: ${addResponse.status}`
                    );
                }

                console.log('[CPB] product added to cart');

                if (data.redirect) {
                    location.href = '/cart';
                }
            } catch (error) {
                console.error('[CPB Cart]', error);
            }
        };
    }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
        customAddToCart();
    });
})();